import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import AppLayout from './components/layout/AppLayout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AddVoucherPage from './pages/AddVoucherPage';
import VoucherListPage from './pages/VoucherListPage';
import VoucherDetailPage from './pages/VoucherDetailPage';
import ApprovalsPage from './pages/ApprovalsPage';
import AdvancesPage from './pages/AdvancesPage';
import CategoriesPage from './pages/CategoriesPage';
import EmployeesPage from './pages/EmployeesPage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<AppLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="vouchers" element={<VoucherListPage />} />
            <Route path="vouchers/new" element={<AddVoucherPage />} />
            <Route path="vouchers/:id" element={<VoucherDetailPage />} />
            <Route path="approvals" element={<ApprovalsPage />} />
            <Route path="advances" element={<AdvancesPage />} />
            <Route path="categories" element={<CategoriesPage />} />
            <Route path="employees" element={<EmployeesPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
